import {  putRequest } from "../httpMethods";

export const putSchoolProfile= (payload) =>
    putRequest(`school/profile`, payload);